let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iZIXR")).then(() => parcelRequire('jEppW'));